export const ApiEndpoints = Object.freeze({
  ADDRESSES: "/addresses",
  AUDIT_LOGS: "/audit-logs",
  AUTH: "/auth",
  B2B: "/b2b",
  B2B_ORDERS: "/b2b-orders",
  B2B_PREORDERS: "/b2b-preorders",
  BO_USERS: "/bo/users",
  BRANDS: "/brands",
  CARDS: "/cards",
  CASHBACK: "/cashback",
  CATEGORIES: "/categories",
  COINS: "/coins",
  CONSIGNMENT: "/consignment",
  COUPONS: "/coupons",
  CROSS_PROJECT: "/cross-project",
  HEALTH: "/health",
  INVENTORY: "/inventory",
  IPS: "/ips",
  NOTIFICATIONS: "/notifications",
  ORDERS: "/orders",
  PAYMENT_METHODS: "/payment-methods",
  PERMISSIONS: "/permissions",
  PREORDER: "/preorder",
  PRODUCTS: "/products",
  QUOTES: "/quotes",
  REDEMPTION_RULES: "/redemption-rules",
  RMA: "/rma",
  ROLES: "/roles",
  SETTINGS: "/settings",
  STOCK_TRANSFERS: "/stock-transfers",
  STORAGE: "/storage",
  SUPPLIERS: "/suppliers",
  SYSTEM: "/system",
  TAX: "/tax",
  TIERS: "/tiers",
  TRANSACTIONS: "/transactions",
  USERS: "/users",
  WALLETS: "/wallets",
  WAREHOUSES: "/warehouses",
});
